(function () {
  'use strict';

  function perView(root) {
    var value = parseInt(getComputedStyle(root).getPropertyValue('--ic-per-view'), 10);
    return value > 0 ? value : 1;
  }

  function initCarousel(root) {
    if (!root || root.getAttribute('data-ic-ready') === 'true') return;

    var track = root.querySelector('[data-carousel-track]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    if (!track || !prevBtn || !nextBtn) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]'));
    if (!slides.length) return;

    root.setAttribute('data-ic-ready', 'true');

    var index = 0;
    var dots = [];

    function maxIndex() {
      return Math.max(0, slides.length - perView(root));
    }

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function buildDots() {
      if (!dotsWrap) return;
      var count = maxIndex() + 1;
      if (dots.length === count) return;
      dotsWrap.innerHTML = '';
      dots = [];
      if (count < 2) {
        dotsWrap.hidden = true;
        return;
      }
      dotsWrap.hidden = false;
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ingredients-carousel__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', goTo.bind(null, i));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function render() {
      index = Math.max(0, Math.min(index, maxIndex()));
      track.style.transform = 'translate3d(' + -index * step() + 'px, 0, 0)';
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= maxIndex();
    }

    function goTo(i) {
      index = i;
      render();
    }

    prevBtn.addEventListener('click', function () {
      goTo(index - 1);
    });
    nextBtn.addEventListener('click', function () {
      goTo(index + 1);
    });

    // Swipe on touch screens
    var startX = null;
    var startY = null;
    var swiped = false;
    track.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swiped = false;
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          goTo(dx < 0 ? index + 1 : index - 1);
        }
        startX = null;
      },
      { passive: true }
    );

    // Tap a card on mobile to show its hover image
    slides.forEach(function (slide) {
      var card = slide.querySelector('.ingredients-carousel__card.has-hover');
      if (!card) return;
      card.addEventListener('click', function () {
        if (swiped || window.matchMedia('(hover: hover)').matches) return;
        card.classList.toggle('is-flipped');
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildDots();
        render();
      }, 120);
    });

    // Theme editor: jump to the block being edited
    document.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i === -1) return;
      root.classList.add('is-visible');
      goTo(i);
    });

    buildDots();
    render();
    initReveal(root);
  }

  function initReveal(root) {
    var inEditor = window.Shopify && window.Shopify.designMode;
    if (inEditor || !('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }
    root.classList.add('is-ready');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ingredients-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();